import { menuselect } from "@/constant/menuselect";

let str = "产品概述";
export const config = {
  title: "智慧人事",
  headerInfo:
    "敬在智能人事管理系统基于敏捷研发体系和前沿的开发技术，采用现代化全新的技术框架和产品设计理念设计产品，不仅仅是对人力资源管理六大模块做信息化支撑，而是一套面向医院人力资源管理，以人力资源管理三支柱为业务导向，依托于智慧医院核心理念基础之上的全新应用实践，更符合医院未来发展和管理的现实需要。",
  headerImg: require("@/assets/images/humanResources/Rectangle 19header.svg"),
  activeTitle: str,
  activeSubTitle: str,
  navList: [
    {
      name: "智慧人事",
      children: menuselect(),
    },
    {
      name: "产品概述",
      desc: "敬在智能人事管理系统基于敏捷研发体系和前沿的开发技术，采用现代化全新的技术框架和产品设计理念设计产品，不仅仅是对人力资源管理六大模块做信息化支撑，而是一套面向医院人力资源管理，以人力资源管理三支柱为业务导向，依托于智慧医院核心理念基础之上的全新应用实践，更符合医院未来发展和管理的现实需要。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/humanResources/Group 827.svg"),
        },
      ],
    },
    {
      name: "打造人才闭环",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/humanResources/Group 897.svg"),
        },
      ],
    },
    {
      name: "系统特点及应用价值",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/humanResources/Frame 904.svg"),
        },
      ],
    },
  ],
};
